import Form from './Form'
(function() {
    const $radioButtonGroups =  document.querySelectorAll('.radio-group')
    $radioButtonGroups.forEach($r => new Form.RadioGrp($r))
    const $checkboxGroups =  document.querySelectorAll('.checkbox-group')
    $checkboxGroups.forEach($c => new Form.CheckboxGrp($c))
})()